<template lang="pug">
  image(width="760" height="280" :href="filePath")
</template>

<script>
export default {
  name: 'svg-external',
  props: {
    path: String,
    width: String,
  },

  computed: {
    filePath() {
      return require(`../../assets/svg/${this.path}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-external {
}
</style>
